import { useEffect, useRef } from 'react';
import {
    getAdsenseClient,
    isAdsenseEnabled,
    loadAdsenseScript,
} from '../../../services/adsense';

export const AdSlot = ({
    slotId,
    format = 'auto',
    layout,
    layoutKey,
    responsive = true,
    style,
    className,
}) => {
    const insRef = useRef(null);
    const pushedRef = useRef(false);

    useEffect(() => {
        if (!isAdsenseEnabled() || !slotId) return undefined;
        let cancelled = false;

        loadAdsenseScript().then((ok) => {
            if (!ok || cancelled || pushedRef.current) return;
            if (!insRef.current) return;
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
                pushedRef.current = true;
            } catch (_) {}
        });

        return () => {
            cancelled = true;
        };
    }, [slotId]);

    if (!isAdsenseEnabled() || !slotId) return null;

    const client = getAdsenseClient();
    if (!client) return null;

    const dataAttrs = {
        'data-ad-client': client,
        'data-ad-slot': slotId,
        'data-ad-format': format,
    };
    if (layout) dataAttrs['data-ad-layout'] = layout;
    if (layoutKey) dataAttrs['data-ad-layout-key'] = layoutKey;
    if (responsive) dataAttrs['data-full-width-responsive'] = 'true';

    return (
        <ins
            ref={insRef}
            className={`adsbygoogle ${className || ''}`.trim()}
            style={{ display: 'block', textAlign: 'center', ...style }}
            {...dataAttrs}
        />
    );
};

export default AdSlot;
